import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import Hero from "./components/Hero";
import Categories from "./components/Categories";
import FeaturedProducts from "./components/FeaturedProducts";
import Technology from "./components/Technology";
import BrandStory from "./components/BrandStory";
import FinalCTA from "./components/FinalCTA";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-100">
      <SiteHeader />
      <main>
        <Hero />
        <Categories />
        <FeaturedProducts />
        <Technology />
        <BrandStory />
        <FinalCTA />
      </main>
      <SiteFooter />
    </div>
  );
}